
.shopping-cart-btn {
    margin-left: 0;
    padding: 0;
    background: #E2002A;
    color: #fff;
    display: inline-block;
    font-size: 16px;
    border: none;
    cursor: pointer;
    transform: skew(28deg);

    @media #{$screen-min-lg} {
        padding: 0;

        .header-is-sticky & {
            padding: 0 7px 0 33px;
        }
    }

    &:hover,
    &:focus {
        background: white;
        color: #E2002A;

    }

    span {
        display: inline-block;
        font-size: 16px;
        line-height: 50px;
    }

    .shopping-cart-btn__icon {
        display: none;

        @media #{$screen-min-md} {
            display: inline-block;
            margin-right: 8px;
            width: 14px;
            height: 14px;
            transform: translateY(0);
        }
    }
}
